import {IPortalseite, ITestheftvarianten} from "./Interfaces";
import Veraportal from "./Veraportal";
import VeraApi from "./VeraApi";
import {ISchueler_gruppenDB, ISchuelerDB} from "./InterfacesDB";
import Utilities from "./Utilities";
import Modal from "./Modal";
import Tooltip, {TOOLTIP_INHALTE} from './Tooltip';

export default class Schuelerverwaltung extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        this.refreshSchuelerverwaltung(); // zum ersten mal die Schüler-Verwaltung aufrufen

        //region Schülerverwaltung Navigationsbuttons initialisieren

        //region direkt eine Schüler:in an Liste anhängen
        $(`.schueler-hinzufuegen-button`).on('click', async () => {

            // TODO:HIGH wenn gerade eine gefilterte Gruppe von Schüler angesehen wird, direkt dieser Gruppe hinzufügen
            // let gruppen: IGruppe[] = [];
            // let filterGruppeId: number = ($(`#schuelerliste-filter`).val().toString() !== '-') ? parseInt($(`#schuelerliste-filter`).val().toString()) : null;
            // if (filterGruppeId !== null) {
            //     gruppen.push({gruppe_id: filterGruppeId});
            // }

            const api = VeraApi.getInstance(this);
            try {
                let response: ISchuelerDB[] = await api.postEmptySchuelers(1);
                this.schuelerliste.push(response[0]);
                this.refreshSchuelerverwaltung();
            } catch (e) {
                Utilities.errorToSentry(e);
            }
        });
        //endregion

        this.refreshFilterOptionen();
        //endregion

        //region Sprungmarken für Schüler ansteuern
        let sprungmarkeSchuelerId: number = this.sessionvariablen.get['schuelerid'] ?? null;
        let sprungmarkeSchuelerNr: number = this.sessionvariablen.get['schuelernr'] ?? null;

        //Zu Schüler springen
        try {
            if (sprungmarkeSchuelerId !== null || sprungmarkeSchuelerNr !== null) {
                let schuelerDom = document.querySelector(`div.schuelerverwaltung div.schueler[data-schuelerid='${sprungmarkeSchuelerId}'], div.schuelerverwaltung div.schueler[data-nr='${sprungmarkeSchuelerNr}']`);
                schuelerDom.scrollIntoView({block: "center"});
                schuelerDom.classList.add('sprungmarke-highlight');
                setTimeout(() => {
                    schuelerDom.classList.remove('sprungmarke-highlight');
                }, 3000);
            }
        } catch (e) {
            Utilities.errorToSentry(e);
        }

        //Parameter aus URL-Bar entfernen
        try {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);
            params.delete('schuelerid');
            params.delete('itemid');
            params.delete('schuelernr');
            window.history.pushState({}, document.title, '?' + params.toString());
        } catch {
            //
        }
        //endregion

        // wenn globaler onTresorOffen-Event feuert Namenfelder initialisieren und Timer starten
        document.addEventListener("onTresorOffen", (e) => {
            // Klarnamen Textfelder initialisieren
            if (this.tresor?.offen === true) {
                this.tresor.klarnamenFelderInitialisieren();
            }

            document.querySelectorAll(`.hinweis-klarnamenfunktion`)
                .forEach(e => e.classList.add('hidden'));
        });

        if (this.sessionvariablen.user.accounttyp === 8)
            document.querySelectorAll(`.hinweis-klarnamenfunktion`)
                .forEach(e => e.classList.add('hidden'));

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        this.pushLoop(); // Push-Loop speichert alle refresh_update_msec die Änderungen in der Schuelerliste


        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        if (this.tresor?.offen === true) {
            await this.tresor.writeKlarnamenToBlob();
        }

        // Schüler-Verwaltung speichern, bevor die Seite wechselt
        await this.pushSchuelersToApi();

        return true;
    }

    /**
     * Übermittelt Änderungen von Schülern an die API und aktualisiert deren Eigenschaften und Gruppenzuweisungen.
     *
     * Die Methode führt folgende Hauptoperationen durch:
     * - Identifiziert Schüler mit Änderungen (markiert durch data-changed='1' Attribut)
     * - Sammelt geänderte Schülereigenschaften (Geschlecht, Statusflags, modifizierte Testhefte etc.)
     * - Erfasst Änderungen bei Stammklassenzuweisungen
     * - Sendet Schülereigenschaften über putSchuelerEigenschaften() an die API
     * - Behandelt Löschung und Einfügung von Schülergruppenzuweisungen
     * - Aktualisiert lokale Schüler- und Gruppenzuweisungslisten
     * - Aktualisiert die Schülerverwaltungsansicht nach erfolgreichen Updates
     *
     * @returns {Promise<boolean>}
     * - Gibt true zurück, wenn alle Updates erfolgreich waren
     * - Gibt false zurück, wenn:
     *   - Keine geänderten Schüler gefunden wurden
     *   - Keine Schülerverwaltungsliste existiert
     *   - Ein Fehler bei der API-Kommunikation auftritt
     *
     * @throws {Error} Behandelt Fehler stillschweigend und löst das Promise mit false auf
     */
    public pushSchuelersToApi(): Promise<boolean> {
        if (document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste`)?.length === 0) return new Promise((resolve) => {
            resolve(false);
        });

        return new Promise(async (resolve) => {
            let changedSchuelerArrDOM: NodeListOf<HTMLElement> = document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler[data-changed='1']`);
            if (changedSchuelerArrDOM.length === 0) {
                resolve(false);
                return;
            }

            let changedSchuelerArr: ISchuelerDB[] = [];
            let changedSchuelerGruppeZuordnungArr: ISchueler_gruppenDB[] = [];
            for (let s = 0; s < changedSchuelerArrDOM.length; s++) {
                try {
                    // TODO:medium data-changed für Eigenschaften und Stammklasse trennen und damit je ein API push sparen

                    // geänderte Schüler-Eigenschaften sammeln
                    changedSchuelerArr.push({
                        nr: parseInt(changedSchuelerArrDOM[s]?.getAttribute('data-nr')),
                        geschlecht: parseInt((changedSchuelerArrDOM[s].querySelector(`.geschlecht input[type='radio']:checked`) as HTMLInputElement)?.value) ?? null,
                        is_f: ((changedSchuelerArrDOM[s].querySelector(`input.is_f`) as HTMLInputElement)?.checked) ? 1 : 0,
                        is_s: ((changedSchuelerArrDOM[s].querySelector(`input.is_s`) as HTMLInputElement)?.checked) ? 1 : 0,
                        is_kw: ((changedSchuelerArrDOM[s].querySelector(`input.is_kw`) as HTMLInputElement)?.checked) ? 1 : 0,
                        is_tm: ((changedSchuelerArrDOM[s].querySelector(`input.is_tm`) as HTMLInputElement)?.checked) ? 1 : 0,
                        is_td: ((changedSchuelerArrDOM[s].querySelector(`input.is_td`) as HTMLInputElement)?.checked) ? 1 : 0,
                        is_nd: ((changedSchuelerArrDOM[s].querySelector(`input.is_nd`) as HTMLInputElement)?.checked) ? 1 : 0,
                        modifizierte_testhefte: ((changedSchuelerArrDOM[s].querySelector(`select.modifiziertes-testheft`) as HTMLSelectElement)?.value !== '-') ? (changedSchuelerArrDOM[s].querySelector(`select.modifiziertes-testheft`) as HTMLSelectElement)?.value : null,
                        f_zieldifferenz_ni: ((changedSchuelerArrDOM[s].querySelector(`input.is_f`) as HTMLInputElement)?.checked) ? (((changedSchuelerArrDOM[s].querySelector(`select.f-zieldifferenzierung`) as HTMLSelectElement)?.value !== '-') ? (changedSchuelerArrDOM[s].querySelector(`select.f-zieldifferenzierung`) as HTMLSelectElement)?.value : null) : null,
                        pseudonym_hb: changedSchuelerArrDOM[s].getAttribute('data-pseudonym-hb') ?? null,
                        is_deaktiviert: ((changedSchuelerArrDOM[s].querySelector(`input.is_deaktiviert`) as HTMLInputElement)?.value === '1') ? 1 : 0,
                    });

                    // geänderte Stammklassenzuweisungen sammeln
                    let stammklasseDOM = (changedSchuelerArrDOM[s].querySelector('select.stammklasse') as HTMLInputElement);
                    if (stammklasseDOM?.getAttribute('data-stammklasse-changed') === '1') {
                        changedSchuelerGruppeZuordnungArr.push({
                            schueler_id: parseInt(changedSchuelerArrDOM[s].getAttribute('data-schuelerid')),
                            gruppe_id: (isNaN(parseInt(stammklasseDOM.value)) === false) ? parseInt(stammklasseDOM.value) : null
                        });
                    }

                } catch (e) {
                    Utilities.errorToSentry(e);

                    resolve(false);
                    return;
                }
            }

            try {
                // Stammklassen vor Änderungen bestimmen
                let schuelerGruppenOld = changedSchuelerGruppeZuordnungArr.map(c => {
                    return this.schuelerGruppenZuweisungen
                        .filter(sg =>
                            sg.schueler_id === c.schueler_id &&
                            this.gruppenliste.filter(
                                g =>
                                    g.typ === 'STAMMKLASSE'
                            ).map(a => a.gruppe_id).includes(sg.gruppe_id)
                        )[0] ?? null;
                }).filter(e => e !== null) ?? [];

                // Schüler-Eigenschaften und Gruppenzuordnungen abschicken
                const api = VeraApi.getInstance(this);
                let responseSchuelers = await api.putSchuelerEigenschaften(changedSchuelerArr);

                let responseDeleteGruppenZuordnung: ISchueler_gruppenDB[] = [];
                if (schuelerGruppenOld.filter(sg => sg.gruppe_id !== null).length !== 0) {
                    responseDeleteGruppenZuordnung = await api.deleteSchuelerGruppenZuweisungen(
                        schuelerGruppenOld.filter(sg => sg.gruppe_id !== null)
                    );
                }

                let responseInsertGruppenZuordnung: ISchueler_gruppenDB[] = [];
                if (changedSchuelerGruppeZuordnungArr.filter(sg => sg.gruppe_id !== null).length !== 0) {
                    responseInsertGruppenZuordnung = await api.postSchuelerGruppenZuweisungen(
                        changedSchuelerGruppeZuordnungArr.filter(sg => sg.gruppe_id !== null)
                    );
                }

                // Gruppenzuordnungen aktualisieren
                if (responseDeleteGruppenZuordnung.length > 0) {
                    for (const deletedZuordnung of responseDeleteGruppenZuordnung) {
                        let index = this.schuelerGruppenZuweisungen.findIndex(
                            e =>
                                e.schueler_id === deletedZuordnung.schueler_id &&
                                e.gruppe_id === deletedZuordnung.gruppe_id
                        );
                        if (index !== -1) {
                            this.schuelerGruppenZuweisungen.splice(index, 1);
                        }
                    }
                }

                // changed-Attribut an Schüler:in zurücksetzen
                for (const changedSchueler of responseSchuelers) {
                    document.querySelector(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler[data-schuelerid='${changedSchueler.schueler_id}']`)
                        ?.setAttribute('data-changed', '0');
                }

                // Schülerliste global aktualisieren
                for (const changedSchueler of responseSchuelers) {
                    let index = this.schuelerliste.findIndex(e => e.schueler_id === changedSchueler.schueler_id);
                    this.schuelerliste[index] = changedSchueler;
                }

                // Gruppenzuordnung global aktualisieren
                for (const changedGruppenZuordnung of responseInsertGruppenZuordnung) {
                    this.schuelerGruppenZuweisungen.push(changedGruppenZuordnung);
                }

                this.refreshSchuelerverwaltung();
                resolve(true);
            } catch (e) {
                Utilities.errorToSentry(e);

                resolve(false);
            }
        });
    }

    //region HTML-Ausschnitte
    private schueler_schuelerlisteHTML = (
        {schueler_id, nr, geschlecht, is_f, is_s, is_kw, is_tm, is_td, is_nd, modifizierte_testhefte, f_zieldifferenz_ni, pseudonym_hb, is_deaktiviert, ausgeklappt}: (ISchuelerDB & { ausgeklappt?: boolean })
    ) => {
        const deaktivierenTitel = (is_deaktiviert === 1) ? 'Schüler:in wieder einblenden' : 'Schüler:in deaktivieren';
        const deaktivierenText = (is_deaktiviert === 1)
            ? 'Die Schüler:in wird wieder in den folgenden Ansichten berücksichtigt.'
            : 'Die Schüler:in wird in Testheftbestellung, Durchführung und Rückmeldungen nicht mehr berücksichtigt. Das Ausblenden kann jederzeit rückgängig gemacht werden.';

        return `
<div class="schueler" data-schuelerid="${schueler_id}"
data-nr="${nr}" data-deaktiviert="${is_deaktiviert}"
data-markiert="0"
data-changed="0"
data-rendered="0"
data-ausgeklappt="${((ausgeklappt ?? false) === false) ? `0` : `1`}"
${(this.sessionvariablen.schule.land === 'hb' && pseudonym_hb !== null) ? `data-pseudonym-hb="${pseudonym_hb}"` : ``}
>
    <div class="wichtige-eigenschaften">
        <div class="caret">
            <svg role="graphics-symbol" class="caret-right">
                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#caret-right-fill"/>
            </svg>
            <svg role="graphics-symbol" class="caret-down">
                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#caret-down-fill"/>
            </svg>
        </div>
        <div class="markierung" data-tooltip="${Tooltip.html`
            <p><strong>Schülerinnen und Schüler markieren</strong></p>
            <p>Markieren Sie mehrere Schülerinnen und Schüler, um deren Eigenschaften gemeinsam anzupassen.</p>
        `}"><label for="markierung-${nr}"><input type="checkbox" class="markierung" id="markierung-${nr}"/></label></div>
        <div class="schuelernummer">
            <div class="nummer" data-tooltip="${Tooltip.html`
                <p><strong>Schülernummer</strong></p>
                <p>Jahrgangsstufenspezifische Nummer dieser Schüler:in.</p>
            `}">${nr.toString().padStart(3, '0')}</div>
            ${(this.sessionvariablen.schule.land === 'hb') ?
            `<div class="pseudonym-hb" data-tooltip="${Tooltip.html`
                <p><strong>Schülercode Bremen</strong></p>
                <p>Schülerspezifisches Pseudonym. Klicken Sie zum Eintragen oder Bearbeiten auf den Wert.</p>
            `}">${pseudonym_hb ?? `<i style="color: darkred;">FEHLT!</i>`}</div>`
            : ``}
        </div>
        <div class="schuelername"
            ${(this.tresor?.offen === false && this.sessionvariablen.user.accounttyp !== 8) ? `data-tooltip="${Tooltip.html`
                <p><strong>Klarnamenfunktion nicht aktiviert</strong></p>
                <p>Aktivieren Sie die Klarnamenfunktion oben rechts, um Namen zu hinterlegen. Diese bleiben anschließend überall im Portal verfügbar.</p>
            `}"` : ``}
            ${(this.sessionvariablen.user.accounttyp === 8) ? `data-tooltip="${Tooltip.html`
                <p><strong>Klarnamenfunktion nicht verfügbar</strong></p>
                <p>Für neunte Klassen im Fach Französisch steht die Klarnamenfunktion nicht zur Verfügung.</p>
            `}"` : ``}
        >
            <input type="text" class="schuelername tresor" id="schuelername-${nr}" maxlength="20" placeholder="Schüler:in ${nr.toString().padStart(3, '0')}"
            autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" value=""
            ${(this.tresor?.offen === false && this.sessionvariablen.user.accounttyp !== 8) ? `disabled="disabled"` : ``}
            ${(this.sessionvariablen.user.accounttyp === 8) ? `disabled="disabled"` : ``}
            />
        </div>
        <div class="geschlecht">
            <label for="is_m-${nr}" data-tooltip="${Tooltip.html`<p><strong>Männlich</strong></p>`}"><input type="radio" class="is_m" id="is_m-${nr}" value="1" name="geschlecht-${nr}" ${(geschlecht === 1) ? 'checked' : ''}/>
                <svg role="graphics-symbol">
                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-male"/>
                </svg>
            </label>
            <label for="is_w-${nr}" data-tooltip="${Tooltip.html`<p><strong>Weiblich</strong></p>`}"><input type="radio" class="is_w" id="is_w-${nr}" value="2" name="geschlecht-${nr}" ${(geschlecht === 2) ? 'checked' : ''}/>
            <svg role="graphics-symbol">
                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-female"/>
            </svg>
            </label>
            <label for="is_d-${nr}" data-tooltip="${Tooltip.html`<p><strong>Divers</strong></p>`}"><input type="radio" class="is_d" id="is_d-${nr}" value="3" name="geschlecht-${nr}" ${(geschlecht === 3) ? 'checked' : ''}/>
                <svg role="graphics-symbol">
                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-ambiguous"/>
                </svg>
            </label>
        </div>
        <div class="eigenschaften">
            <div>
            ${(this.sessionvariablen.projekt.weiche === 'vera8') ? `
            ${(['nw', 'rp', 'sl', 'hb', 'dg', 'as'].includes(this.sessionvariablen.schule.land)) ? `
                <label for="is_f-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.sonderpaedagogischerFoerderbedarf}"><input type="checkbox" class="is_f" id="is_f-${nr}" name="is_f-${nr}" ${(is_f === 1) ? 'checked' : ''}/>F</label>
            ` : ``}
            ${(['ni'].includes(this.sessionvariablen.schule.land)) ? `
                <div class="eigenschaft-2 f-zieldifferenz">
                    <label for="is_f-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.sonderpaedagogischerUnterstuetzungsbedarf}"><input type="checkbox" class="is_f" id="is_f-${nr}" name="is_f-${nr}" ${(is_f === 1) ? 'checked' : ''}/>F</label>
                    <div class="select-eigenschaft ${(is_f === 1) ? 'active' : ''}">
                        <label for="f-zieldifferenzierung-${nr}" data-tooltip="${Tooltip.html`
                            <p><strong>Zieldifferenzierung</strong></p>
                            <p>Wird die Schüler:in mit sonderpädagogischem Unterstützungsbedarf zieldifferent oder zielgleich unterrichtet?</p>
                        `}">
                            <select class="f-zieldifferenzierung small" id="f-zieldifferenzierung-${nr}">
                                <option value="different" ${(f_zieldifferenz_ni === 'different') ? `selected` : ``}>zieldifferent</option>
                                <option value="gleich" ${(f_zieldifferenz_ni === 'gleich') ? `selected` : ``}>zielgleich</option>
                            </select>
                        </label>
                    </div>
                </div>
            ` : ``}
            ${(['ni', 'rp', 'sl', 'hb', 'dg', 'as'].includes(this.sessionvariablen.schule.land)) ? `
                <label for="is_s-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.unzureichendeSprachbeherrschung}"><input type="checkbox" class="is_s" id="is_s-${nr}" name="is_s-${nr}" ${(is_s === 1) ? 'checked' : ''}/>S</label>
            ` : ``}
            ${(['ni', 'rp', 'sl'].includes(this.sessionvariablen.schule.land)) ? `
                <div class="eigenschaft-2">
                    <label for="is_tm-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.teilleistungsstoerungMathematik}"><input type="checkbox" class="is_tm" id="is_tm-${nr}" name="is_tm-${nr}" ${(is_tm === 1) ? 'checked' : ''}/>TM</label>
                    <label for="is_td-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.teilleistungsstoerungDeutsch}"><input type="checkbox" class="is_td" id="is_td-${nr}" name="is_td-${nr}" ${(is_td === 1) ? 'checked' : ''}/>TD</label>
                </div>
            ` : ``}
            ${(['hb', 'rp', 'sl', 'nw'].includes(this.sessionvariablen.schule.land)) ? `
                <label for="is_nd-${nr}" class="eigenschaft-1" data-tooltip="${TOOLTIP_INHALTE.deutschNichtDominanteSprache}"><input type="checkbox" class="is_nd" id="is_nd-${nr}" name="is_nd-${nr}" ${(is_nd === 1) ? 'checked' : ''}/>ND</label>
            ` : ``}
            ${(['rp', 'sl', 'nw'].includes(this.sessionvariablen.schule.land)) ? `
                <label for="is_kw-${nr}" class="eigenschaft-2" data-tooltip="${TOOLTIP_INHALTE.klassenwiederholung}"><input type="checkbox" class="is_kw" id="is_kw-${nr}" name="is_kw-${nr}" ${(is_kw === 1) ? 'checked' : ''}/>KW</label>
                 ` : ``}

            ${(this.sessionvariablen.schule.land === 'nw' && (this.sessionvariablen.schule.schulform === 'FS' || this.sessionvariablen.schule.schulform === null)) ? `
                <div class="select-eigenschaft eigenschaft-2">
                    <label for="modifiziertes-testheft-${nr}"
                    data-tooltip="${Tooltip.html`
                        <p><strong>Modifizierte Testhefte</strong></p>
                        <p>Für Mathematik, Deutsch und Englisch können modifizierte Testmaterialien bereitgestellt werden. Wählen Sie die erforderliche Variante.</p>
                    `}"
                    >
                        Modifizierte Testhefte:<br/>
                        <select class="modifiziertes-testheft small eigenschaft-2" id="modifiziertes-testheft-${nr}">
                            <option value="-" ${(modifizierte_testhefte === null) ? `selected` : ``}>nicht modifiziert</option>
                            <option value="bl" ${(modifizierte_testhefte === 'bl') ? `selected` : ``}>blind</option>
                            <option value="sh" ${(modifizierte_testhefte === 'sh') ? `selected` : ``}>sehbehindert</option>
                            <option value="gh" ${(modifizierte_testhefte === 'gh') ? `selected` : ``}>gehörlos</option>
                            <option value="sg" ${(modifizierte_testhefte === 'sg') ? `selected` : ``}>schwerhörig</option>
                            <option value="sb" ${(modifizierte_testhefte === 'sb') ? `selected` : ``}>Sprache</option>
                        </select>
                    </label>
                </div>
            ` : ``}
            ` : ``}
            
            ${(this.sessionvariablen.projekt.weiche === 'vera5') ? `
                <label for="is_f-${nr}" class="eigenschaft-1" data-tooltip="${Tooltip.html`
        <p><strong>Sonderpädagogischer Förderbedarf</strong></p>
        <p>Schülerinnen und Schüler mit festgestelltem sonderpädagogischen Förderbedarf gehen nicht in aggregierte Rückmeldungen mit ein.</p>
    `}"><input type="checkbox" class="is_f" id="is_f-${nr}" name="is_f-${nr}" ${(is_f === 1) ? 'checked' : ''}/>F</label>
            ` : ``}
            </div>
        </div>
        
        ${(this.sessionvariablen.user.accounttyp !== 8) ? `
        <div class="stammklasse">
            <label for="stammklasse-${nr}"
            data-tooltip="${Tooltip.html`
                <p><strong>Stammklasse</strong></p>
                <p>In dieser Gruppe werden die Schülerinnen und Schüler gemeinsam und nicht differenziert unterrichtet.</p>
                <p>Bei Unterricht im Kurssystem müssen zusätzlich fachspezifische, differenzierte Kurse angelegt werden.</p>
            `}"
            >Stammklasse:</label>
            <select class="stammklasse" id="stammklasse-${nr}" data-stammklasse-changed="0">
                <option value="-">keine Stammklasse</option>
        ${this.gruppenliste.filter((g) => {
            return g.typ === 'STAMMKLASSE'
        }).map((g) => {
            g.selected = (this.schuelerGruppenZuweisungen.filter((sg) => {
                return (sg.schueler_id === schueler_id && sg.gruppe_id === g.gruppe_id)
            }).length > 0)
            return g;
        }).map(this.gruppeOptionHTML).join('')}
            </select>
        </div>
        ` : ``}
        <div class="optionen">
            <button class="deaktivieren-btn ${(is_deaktiviert === 1) ? 'deaktiviert' : ''}" aria-label="${deaktivierenTitel}" data-tooltip="${Tooltip.html`
                <p><strong>${deaktivierenTitel}</strong></p>
                <p>${deaktivierenText}</p>
            `}">
                <svg role="graphics-symbol" class="icon-is-not-deaktiviert">
                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#eye-slash"/>
                </svg>
                <svg role="graphics-symbol" class="icon-is-deaktiviert">
                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#eye"/>
                </svg>
            </button>
            <input type="hidden" class="is_deaktiviert" id="is_deaktiviert-${nr}" name="is_deaktiviert-${nr}" value="${(is_deaktiviert === 1) ? '1' : '0'}" />
        </div>
    </div>
    <div class="erweiterte-eigenschaften">
        <!-- deaktiviert -->
    </div>
</div>
`;
    };

    // Gruppeneditierungsbuttons etwas zeitverzögert initialisieren
    private tsGruppeFocusFunction = async () => {
        setTimeout(() => {
            $(`.gruppe-option .edit-stammklasse-btn`).off('click.editstammklassebtn');
            $(`.gruppe-option .edit-stammklasse-btn`).on('click.editstammklassebtn', (evt) => {
                evt.stopPropagation();
                this.stammklasseEditieren(parseInt($(evt.target).attr('data-gruppeid')) ?? null)
            });
            $(`.gruppe-option .edit-kurs-btn`).off('click.editkursbtn');
            $(`.gruppe-option .edit-kurs-btn`).on('click.editkursbtn', (evt) => {
                evt.stopPropagation();
                this.kursEditieren(parseInt($(evt.target).attr('data-gruppeid')) ?? null)
            });
            $(`.gruppe-option .edit-lerngruppe-btn`).off('click.editlerngruppebtn');
            $(`.gruppe-option .edit-lerngruppe-btn`).on('click.editlerngruppebtn', (evt) => {
                evt.stopPropagation();
                this.lerngruppeEditieren(parseInt($(evt.target).attr('data-gruppeid')) ?? null)
            });
        }, 500);
    };

    private testheftOption_schuelerlisteHTML = (
        {testheft_id, bezeichnung, beschreibung, icon, selected}: (ITestheftvarianten & { icon: string; selected: boolean; })
    ) => {
        return `<option value="${testheft_id}" ${(beschreibung !== null) ? `data-beschreibung="${beschreibung}"` : ``} ${(icon !== null) ? `data-icon="${icon}"` : ``} ${((selected ?? false)) ? `selected="selected"` : ``}>${bezeichnung}</option>`;
    };

    //endregion

    private bindEventsFuerSchuelerzeilen() {
        if (document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste`)?.length === 0) return;

        let schuelerzeilenDOM = $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler > div.wichtige-eigenschaften`);
        let markierenCheckboxenDOM = $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler > div.wichtige-eigenschaften .markierung input[type='checkbox']`);
        let allInputsDOM = $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler input:not(.markierung input[type='checkbox']):not(.tresor), div.schuelerverwaltung > div.schuelerliste > div.container div.schueler select`);

        $(markierenCheckboxenDOM).attr("tabindex", -1);
        $(allInputsDOM).attr("tabindex", -1);

        //region Tomselects für Kurse und Testhefte erst bei Klick rendern
        // $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler`).off('click.prerenderts');
        // $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler`).on('click.prerenderts', (evt) => {
        //     let schuelerDOM = $(evt.target).closest(`div.schueler`);
        //     if (schuelerDOM.attr('data-rendered') === '0') {
        //         this.initTomselectKursUndTestheft(schuelerDOM);
        //     }
        // });

        // Tomselects von bereits ausgeklappten direkt rendern
        // let ausgeklappteSchuelerDOMs = $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler[data-ausgeklappt='1']`);
        // for (let s = 0; s < ausgeklappteSchuelerDOMs.length; s++) {
        //     if ($(ausgeklappteSchuelerDOMs[s]).attr('data-rendered') === '0') {
        //         this.initTomselectKursUndTestheft($(ausgeklappteSchuelerDOMs[s]));
        //     }
        // }
        //endregion

        // Ausklapp-Klickevent für Schüler-Zeile
        // schuelerzeilenDOM.off('click.schuelerzeilen');
        // schuelerzeilenDOM.on('click.schuelerzeilen', (evt) => {
        //     if ($(evt.target).is(`input, label, select, option, span.checkmark, button, a`) === true) {
        //         return;
        //     }
        //     let schuelerDOM = $(evt.target).closest(`div.schueler`);
        //
        //     if (schuelerDOM.attr('data-ausgeklappt') === '0') {
        //         schuelerDOM.attr('data-ausgeklappt', '1');
        //     } else {
        //         schuelerDOM.attr('data-ausgeklappt', '0');
        //     }
        // });

        //Markierungs-Checkbox in Schüler-Zeile
        markierenCheckboxenDOM.off('change.markierenCheckboxen');
        markierenCheckboxenDOM.on('change.markierenCheckboxen', (evt) => {
            try {
                let thisSz = $(evt.target).closest('.schueler');
                thisSz.attr('data-markiert', (thisSz.attr('data-markiert') === '0') ? 1 : 0);
            } catch {
                //
            }
        });

        //Changed-Marker für ganze Schülerzeile
        allInputsDOM.off('change.allInputs');
        allInputsDOM.on('change.allInputs', (evt) => {
            try {
                let thisSz = $(evt.target).closest('div.schueler');
                thisSz.attr('data-changed', 1);
            } catch {
                //
            }
        });

        //region Bulkedit Funktionalität, wenn mehrere Zeilen markiert sind
        //Bulkedit für mehrere Schülerzeilen: Checkboxen, Radios und HiddenFields
        document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler input:not(.markierung input[type='checkbox'])`)
            .forEach(e => e.addEventListener('change', (evt) => {
                    try {
                        let target: HTMLInputElement = evt.target as HTMLInputElement;
                        let thisSchuelerzeile: HTMLElement = target.closest(`div.schueler`);
                        if (thisSchuelerzeile.getAttribute('data-markiert') === '1') {
                            let thisControlClass: string = target.getAttribute('class') ?? null;

                            let gleicheControls: NodeListOf<HTMLInputElement> = document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler[data-markiert='1'] input[class='${thisControlClass}']`);

                            if (['checkbox', 'radio'].includes(target.type)) {
                                gleicheControls
                                    .forEach(c =>
                                        c.checked = target.checked
                                    );
                            }
                            if (['hidden'].includes(target.type)) {
                                gleicheControls
                                    .forEach(c =>
                                        c.value = target.value
                                    );
                            }

                            gleicheControls.forEach(c =>
                                c.closest('.schueler')?.setAttribute('data-changed', '1')
                            );
                        }
                    } catch (e) {
                        Utilities.errorToSentry(e);
                    }
                })
            );


        //Bulkedit für mehrere Schülerzeilen: Selectboxen
        $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler select`).off('change.bulkSelect');
        $(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler select`)
            .on('change.bulkSelect', (evt) => {
                try {
                    let thisSchuelerzeile = $(evt.target).closest('div.schueler');
                    if (thisSchuelerzeile.attr('data-markiert') === '1') {
                        // Classnames in Array schreiben und von Tomselect-Klassen reinigen
                        let thisClassesArray = $(evt.target).attr('class').toString().split(' ');
                        let thisCleanedClassesArray = thisClassesArray.filter((c) => {
                            return ['stammklasse', 'kurs', 'testheft', 'mathematik', 'deutsch', 'englisch', 'franzoesisch'].includes(c);
                        });
                        let gleicheControls = $(`
                        div.schuelerverwaltung > div.schuelerliste > div.container div.schueler[data-markiert='1'] select.${thisCleanedClassesArray.join('.')}`).not(`#${evt.target.id}
                    `);
                        for (let c = 0; c < gleicheControls.length; c++) {
                            // @ts-ignore
                            $(gleicheControls)[c].tomselect.setValue($(evt.target).val(), true);
                        }
                        gleicheControls.closest('div.schueler').attr('data-changed', 1);
                    }
                } catch (e) {
                    Utilities.errorToSentry(e);
                }
            });
        //endregion

        //region Stammklasse tom-select Initialisierung
        let stammklasseSelectArr = $(`select.stammklasse`);
        for (let i = 0; i < stammklasseSelectArr.length; i++) {
            let selectId = $(stammklasseSelectArr[i]).prop('id');
            let schuelerDOM = $(`#${selectId}`).closest(`div.schueler`);
            try {
                // @ts-ignore
                let ts = new TomSelect(`#${selectId}`, {
                    create: false,
                    allowEmptyOption: true,
                    controlInput: null,
                    searchField: [],
                    onChange: () => {
                        document.querySelector(`#${selectId}`)?.setAttribute('data-stammklasse-changed', '1');
                    },
                    render: this.tsGruppeRenderOptions,
                    onFocus: () => {
                        // if (schuelerDOM.attr('data-rendered') === '0') {
                        //     this.initTomselectKursUndTestheft(schuelerDOM);
                        // }
                        this.tsGruppeFocusFunction();
                    }
                });

                // wenn bisher keine Stammklassen angelegt wurden disable und Tooltip
                if (this.gruppenliste.filter((g) => {
                    return g.typ === 'STAMMKLASSE'
                }).length < 1) {
                    ts.disable();
                    $(ts.control).prop('title', `Fügen Sie zuerst Stammklassen über den Button "Stammklasse anlegen ..." hinzu.`);
                }
            } catch (e) {
                Utilities.errorToSentry(e);
            }
        }
        //endregion

        // NW mod. Testheft Tomselect initialisieren
        if (this.sessionvariablen.schule.land === 'nw' && (this.sessionvariablen.schule.schulform === 'FS' || this.sessionvariablen.schule.schulform === null)) {
            try {
                let modTestheftSelectArr: NodeListOf<HTMLSelectElement> = document.querySelectorAll(`select.modifiziertes-testheft`);
                for (let i = 0; i < modTestheftSelectArr.length; i++) {
                    let selectId = modTestheftSelectArr[i].id;

                    // @ts-ignore
                    let ts = new TomSelect(`#${selectId}`, {
                        create: false,
                        allowEmptyOption: true,
                        controlInput: null,
                        searchField: []
                    });

                    modTestheftSelectArr[i].addEventListener('change', (evt) => {
                        let target: HTMLSelectElement = evt.target as HTMLSelectElement;
                        if (target.value !== '-') {
                            (target.closest(`div.schueler`).querySelector(`.is_f`) as HTMLInputElement).checked = true;
                        }
                    });
                }

            } catch (e) {
                Utilities.errorToSentry(e);
            }
        }

        // F mit Zieldifferenzierung verknüpfen
        document.querySelectorAll(`div.f-zieldifferenz input[type='checkbox']`)
            .forEach(cb => {
                cb.addEventListener('change', (evt) => {
                    let checkboxDom = ((evt.target as HTMLInputElement) ?? null);
                    let wrapperDom = ((checkboxDom.closest(`div.f-zieldifferenz`) as HTMLDivElement) ?? null);
                    let selectDom = ((wrapperDom.querySelector(`select.f-zieldifferenzierung`) as HTMLSelectElement) ?? null);

                    if (checkboxDom === null || selectDom === null)
                        return;

                    if (checkboxDom.checked === true)
                        wrapperDom.querySelector(`div.select-eigenschaft`)
                            ?.classList.add('active');
                    else
                        wrapperDom.querySelector(`div.select-eigenschaft`)
                            ?.classList.remove('active');
                });
            });

        // Schüler:in deaktivieren Button
        document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler button.deaktivieren-btn`)
            .forEach((b => {
                try {
                    b?.setAttribute('tabindex', '-1');

                    // Toggle Schüler-Deaktivierung
                    b?.addEventListener('click', (e) => {
                        let schuelerDOM = ((e.target as HTMLElement).closest(`div.schueler`) as HTMLElement);
                        let hidden = (schuelerDOM.querySelector(`input.is_deaktiviert`) as HTMLInputElement);
                        let button = (schuelerDOM.querySelector(`button.deaktivieren-btn`) as HTMLButtonElement);
                        if (hidden.value === '0') {
                            button.classList.add('deaktiviert');
                            hidden.value = '1';
                        } else {
                            button.classList.remove('deaktiviert');
                            hidden.value = '0';
                        }
                        hidden.dispatchEvent(new Event('change'));
                    });

                } catch (e) {
                    Utilities.errorToSentry(e);
                }
            }));

        // HB Pseudonym auf Klick ändern oder hinzufügen
        document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste > div.container div.schueler .pseudonym-hb`)
            .forEach((p => {
                try {
                    p.addEventListener('click', (e) => {
                        let schuelerDOM = ((e.target as HTMLElement).closest(`div.schueler`) as HTMLElement);
                        let schuelerPseudonym: string = schuelerDOM.getAttribute('data-pseudonym-hb') ?? null;
                        let schuelerNr: number = parseInt(schuelerDOM.getAttribute('data-nr') ?? '0');

                        let pseudonymEingebenModal = new Modal(this);
                        let pseudonymEingebenModalPromise = pseudonymEingebenModal.show({
                            id: `modal-pseudonym-hb-eingeben`,
                            title: `Schülercode / Pseudonym anpassen`,
                            body: `
                                <p>
                                    Sie können hier den eindeutigen Schülercode des Schülers ${schuelerNr.toString().padStart(3, '0')} anpassen.
                                </p>
                                <label>
                                    <b>Pseudonym (Schülercode):</b><br/>
                                    <input type="text" id="modal-pseudonym-hb-aendern-input" size="10" maxlength="8" value="${schuelerPseudonym ?? ''}"/>
                                </label>
                            `,
                            initFunction: () => {
                                //
                            },
                            validationFunction: () => {
                                let neuesPseudonym: string = (document.querySelector(`input#modal-pseudonym-hb-aendern-input`) as HTMLInputElement)
                                    ?.value.toUpperCase() ?? '';
                                if (neuesPseudonym.length < 5 || neuesPseudonym.length > 8) {
                                    let modal = new Modal(this);
                                    modal.show({
                                        title: `Schülercode fehlerhaft`,
                                        body: `
                                            <p>
                                                Der Schülercode ist in der Regel siebenstellig und ist dem Schülerverzeichnis zu entnehmen.<br/>
                                                Sollte der Schülercode dieses Testteilnehmers unbekannt sein, vergeben Sie einen künstlichen Code
                                                zwischen 5 und 8 Zeichen. Sie können diesen jederzeit anpassen.
                                            </p>
                                        `,
                                        hasSubmit: false,
                                        hasCancel: true,
                                        hasBestaetigung: false,
                                        width: 400,
                                        cancelText: 'OK'
                                    });
                                    return false;
                                }
                            },
                            hasSubmit: true,
                            hasCancel: true,
                            hasBestaetigung: false,
                            submitText: 'Speichern',
                            width: 600,
                        });

                        pseudonymEingebenModalPromise.then(async (modalantwort) => {
                            if (modalantwort === true) {
                                let neuesPseudonym: string = (document.querySelector(`input#modal-pseudonym-hb-aendern-input`) as HTMLInputElement)
                                    ?.value.toUpperCase() ?? '';

                                schuelerDOM.setAttribute('data-pseudonym-hb', neuesPseudonym);
                                schuelerDOM.querySelector(`.pseudonym-hb`).innerHTML = neuesPseudonym;
                                schuelerDOM.setAttribute('data-changed', '1');

                                return true;
                            }
                        });
                    });
                } catch (e) {
                    Utilities.errorToSentry(e);
                }
            }));

        // Klarnamen Textfelder initialisieren
        if (this.tresor?.offen === true) {
            this.tresor.klarnamenFelderInitialisieren();
        }
    }

    /*
    Da die Initialisierung alles anfangs versteckten Tomselects zu hohen Performanceeinbußen geführt hat,
    wird diese jetzt nur bei SuS durchgeführt, die gerade angeklickt werden, die markiert oder ausgeklappt sind
     */
    private initTomselectKursUndTestheft(schuelerDOMs: JQuery<HTMLElement>) {
        for (let s = 0; s < schuelerDOMs.length; s++) {
            //region Kurs Tomselects
            let kursTomselects = $(schuelerDOMs[s]).find(`select.kurs`);
            for (let ts = 0; ts < kursTomselects.length; ts++) {
                let selectId = $(kursTomselects[ts]).prop('id');
                let selectFach = ($(kursTomselects[ts]).is(`.mathematik`)) ? 'ma' : ($(kursTomselects[ts]).is(`.deutsch`)) ? 'de' : ($(kursTomselects[ts]).is(`.englisch`)) ? 'en' : 'fr';
                try {
                    // @ts-ignore
                    let ts = new TomSelect(`#${selectId}`, {
                        create: false,
                        allowEmptyOption: true,
                        controlInput: null,
                        searchField: [],
                        render: this.tsGruppeRenderOptions,
                        onFocus: this.tsGruppeFocusFunction
                    });

                    // wenn bisher keine Kurse angelegt wurden disable und Tooltip
                    if (this.gruppenliste.filter((g) => {
                        return ['KURS', 'LERNGRUPPE'].includes(g.typ) && g.kurs_fach === selectFach
                    }).length < 1) {
                        ts.disable();
                        $(ts.control).prop('title', `Fügen Sie zuerst Kurse dieses Faches über den Button "Kurs anlegen ..." hinzu.`);
                    }
                } catch (e) {
                    Utilities.errorToSentry(e);
                }
            }
            //endregion

            //region Testheft Tomselects
            let testheftSelectArr = $(schuelerDOMs[s]).find(`select.testheft`);
            for (let i = 0; i < testheftSelectArr.length; i++) {
                let selectId = $(testheftSelectArr[i]).prop('id');
                try {
                    // @ts-ignore
                    let ts = new TomSelect(`#${selectId}`, this.tsTestheftOptions);
                    ts.disable(); // Auswahl der Testhefte wird über Stammklasse / Kurse bestimmt, deshalb immer disabled()
                    $(ts.control).prop('title', `Die Auswahl des Testhefts für jede/n Schüler:in wird über die Stammklasse bzw. (wenn im Kurssystem unterrichtet) über den zugewiesenen Kurs bestimmt. Um das Testheft zu ändern, passen Sie die Testheftauswahl in der ganzen Gruppe an oder weisen Sie den/die Schüler:in einer anderen Gruppe zu.`);
                } catch (e) {
                    Utilities.errorToSentry(e);
                }
            }
            //endregion
            $(schuelerDOMs[s]).attr('data-rendered', '1');
        }
    }

    public refreshSchuelerverwaltung(): void {
        if (document.querySelectorAll(`div.schuelerverwaltung > div.schuelerliste`)?.length === 0) return;

        let schuelerliste = this.schuelerliste;

        if (this.sessionvariablen.user.gruppe_id !== null)
            schuelerliste = this.schuelerliste.filter(s => {
                return (
                    this.schuelerGruppenZuweisungen
                        .filter((sg) => {
                            return (sg.schueler_id === s.schueler_id && sg.gruppe_id === this.sessionvariablen.user.gruppe_id)
                        })
                        .length > 0
                )
            })

        if (this.tresor?.offen === true) {
            this.tresor.writeKlarnamenToBlob();
        }

        document.querySelector(`div.schuelerverwaltung > div.schuelerliste > div.schuelerliste-loading`)?.classList.add('active');

        let filterGruppeId: number;
        if (this.sessionvariablen.user.gruppe_id === null)
            filterGruppeId = ($(`#schuelerliste-filter`)?.val().toString() !== '-') ? parseInt($(`#schuelerliste-filter`)?.val().toString()) : null;
        else
            filterGruppeId = null;

        //region Ausklappzustand Schüler-Verwaltung merken
        let ausgeklappteIds: number[] = [];
        let ausgeklappteSchueler = $(`div.schuelerverwaltung > div.schuelerliste > div.container > div.schueler[data-ausgeklappt='1']`);
        for (let s = 0; s < ausgeklappteSchueler.length; s++) {
            ausgeklappteIds.push(parseInt($(ausgeklappteSchueler[s]).attr('data-schuelerid').toString()));
        }
        //endregion

        if (schuelerliste.length > 0) {
            let filteredSchuelerliste = schuelerliste
                .filter((s) => {
                    // wenn kein Filter übergeben wurde, alle ausgeben - ansonsten prüfen ob der Schüler der Filtergruppe zugewiesen ist
                    if (filterGruppeId === null) return true;
                    return (this.schuelerGruppenZuweisungen
                        .filter((sg) => {
                            return (sg.schueler_id === s.schueler_id && sg.gruppe_id === filterGruppeId)
                        }).length > 0)
                }).map((s) => {
                    if (ausgeklappteIds.includes(s.schueler_id)) {
                        //TODO:medium s.ausgeklappt = true;
                    }
                    return s;
                });

            // Schülerliste nur rendern, wenn auch SuS gefiltert wurden
            if (filteredSchuelerliste.length > 0) {
                $(`div.schuelerverwaltung > div.schuelerliste > div.container`).html(
                    filteredSchuelerliste.map(this.schueler_schuelerlisteHTML).join('')
                );
            } else {
                $(`div.schuelerverwaltung > div.schuelerliste > div.container`).html(`Dieser Gruppe sind derzeit noch keine Schüler zugewiesen.`);
            }

            // Anzahl SuS in Slot neben Filter eintragen
            $(`#schuelerliste-filter-anzahl > span.slot`).html(filteredSchuelerliste.length.toString());

            this.initUiStyling();
            this.bindEventsFuerSchuelerzeilen();
        }

        $(`div.schuelerverwaltung > div.schuelerliste > div.schuelerliste-loading`).removeClass('active');
    }

    public async refreshFilterOptionen() {
        if (document.querySelectorAll(`#schuelerliste-filter`)?.length === 0) return;

        //region TomSelect zurücksetzen
        try {
            // @ts-ignore
            document.querySelector(`#schuelerliste-filter`).tomselect.destroy();
        } catch {
            //
        }
        //endregion

        //region HTML mit Optgroups vorgeben
        $(`#schuelerliste-filter`).html(
            `<option value="-" selected>alle SuS anzeigen</option>
            <optgroup label="Stammklassen">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'STAMMKLASSE'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Kurse: Mathematik">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'KURS' && g.kurs_fach === 'ma'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Kurse: Deutsch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'KURS' && g.kurs_fach === 'de'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Kurse: Englisch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'KURS' && g.kurs_fach === 'en'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Kurse: Französisch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'KURS' && g.kurs_fach === 'fr'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Lerngruppen: Mathematik">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'LERNGRUPPE' && g.kurs_fach === 'ma'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Lerngruppen: Deutsch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'LERNGRUPPE' && g.kurs_fach === 'de'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Lerngruppen: Englisch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'LERNGRUPPE' && g.kurs_fach === 'en'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>
            <optgroup label="Lerngruppen: Französisch">
            ${
                this.gruppenliste.filter((g) => {
                    return g.typ === 'LERNGRUPPE' && g.kurs_fach === 'fr'
                }).map((g) => {
                    g.selected = false;
                    return g;
                }).sort((a, b) => {
                    return a.bezeichnung.localeCompare(b.bezeichnung)
                }).map(this.gruppeOptionHTML).join('')
            }
            </optgroup>`
        );
        //endregion

        // @ts-ignore
        new TomSelect(`#schuelerliste-filter`, {
            create: false,
            allowEmptyOption: true,
            controlInput: null,
            searchField: [],
            render: this.tsGruppeRenderOptions,
            onFocus: this.tsGruppeFocusFunction,
            onChange: (value) => {
                this.refreshSchuelerverwaltung(); // Schülerliste neu renden
            }
        });

        $(`#schuelerliste-filter-ts-control`).off('click.schuelerfilter');
        $(`#schuelerliste-filter-ts-control`).on('click.schuelerfilter', () => {
            this.pushSchuelersToApi(); // Schüler übertragen
        });
    }

    /**
     * Versucht alle X (this.sessionvariablen.projekt.schuelerinfos_save_msec) Sekunden
     * Schülerinformationen an den Server zu übertragen.<br/>
     * Verzögerungen bei der Übertragungswiederholung sind an die Schüler-Eigenschaften geknüpft,
     * nicht an die Klarnamen.
     */
    private pushLoop(): void {

        // Schüler-Eigenschaften übertragen
        this.pushSchuelersToApi()
            .then((result) => {
                // console.log('Push-Versuch');
                // console.log(result);
            })
            .catch((error) => {
                // console.log('Push-Error');
                // console.log(result);
            })
            .finally(() => {
                window.setTimeout(() => {
                    this.pushLoop();
                }, this.sessionvariablen.projekt.schuelerinfos_save_msec);
            });

        // Klarnamen übertragen
        this.tresor.writeKlarnamenToBlob()
            .then((result) => {
                // console.log('Klarnamen-Push-Versuch');
                // console.log(result);
            })
            .catch((error) => {
                // console.log('Klarnamen-Push-Error');
                // console.log(result);
            })
    }
}
